var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"p-2 mt-10 border-b4b4b4"},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"media-body align-self-center"},[_c('h5',{staticClass:"font-bold text-xl text-black"},[_vm._v("\n          "+_vm._s(_vm.selectedCourseHome.author
              .map((data) => {
                if (data.userId) {
                  return data.userId.firstname + " " + data.userId.lastname;
                }
              })
              .toString())+"\n        ")]),_c('p',{staticClass:"fsize16 font-normal"},[_vm._v("\n          "+_vm._s(_vm.selectedCourseHome.author
              .map((data) => data.designation)
              .toString())+"\n        ")])])]),_c('p',{staticClass:"fsize16 sm-fsize16 mt-4 font-medium",domProps:{"innerHTML":_vm._s(
        _vm.selectedCourseHome.author.map((data) => data.aboutMe).toString()
      )}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }